export default __webpack_public_path__ + "static/2079-46fbaa7563fb8a9cb785ed2aba79c704.jpg";